import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import LiteratureCoverLetter from '../../_partials/HtmlLiteratureCoverLetter';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
const LiteratureThumbHtmlView = ({ deviation , width , height  })=>/*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames('daeditor-literature-root', getThumbGlobalClassNames(deviation))
    }, /*#__PURE__*/ React.createElement(LiteratureCoverLetter, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-literature-title"
    }, getDeviationTitle(deviation)), /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-literature-text"
    }, deviation.textContent && deviation.textContent.excerpt)));
LiteratureThumbHtmlView.displayName = 'LiteratureThumbHtmlView';
export default LiteratureThumbHtmlView;
